import { Skeleton } from '@mui/material';

function FileTitleLoader(): JSX.Element {
  return <Skeleton width={'60%'} variant={'text'} />;
}

export default FileTitleLoader;
